import {API_ROOT_URL} from 'envs/_current/config'
import {announcementSchema} from './schema'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export {announcementSchema}

export const announcement_create_Api = {
    name: 'announcement_create_Api',
    backend: `Route::post('announcements/create', 'AnnouncementController@create');`,
    root: API_ROOT_URL,
    path: '/announcements/create',
    method: 'POST',
    schema: announcementSchema,
    transform: createTransform(announcementSchema, 'data'),
}

export const announcement_update_Api = {
    name: 'announcement_update_Api',
    backend: `Route::post('announcements/{id}/edit', 'AnnouncementController@update');`,
    root: API_ROOT_URL,
    path: '/announcements/:id/edit',
    method: 'POST',
    schema: announcementSchema,
    transform: createTransform(announcementSchema, 'data'),
}

export const announcement_delete_Api = {
    name: 'announcement_delete_Api',
    backend: `Route::post('announcements/{id}/delete', 'AnnouncementController@delete');`,
    root: API_ROOT_URL,
    path: '/announcements/:id/delete',
    method: 'POST',
    schema: announcementSchema,
    transform: createTransform(announcementSchema, 'data'),
}

export const announcement_getById_Api = {
    name: 'announcement_getById_Api',
    backend: `Route::get('announcements/{id}/get', 'AnnouncementController@getById');`,
    root: API_ROOT_URL,
    path: '/announcements/:id/get',
    method: 'GET',
    schema: announcementSchema,
    transform: createTransform(announcementSchema),
}

export const announcement_gets_Api = {
    name: 'announcement_gets_Api',
    backend: `Route::get('announcements/gets', 'AnnouncementController@gets');`,
    root: API_ROOT_URL,
    path: '/announcements/gets',
    method: 'GET',
    paramsFields: ['owner_type', 'owner_id', 'group_id', 'keyword', 'status', 'subject_id'],
    schema: announcementSchema,
    transform: createListTransform(announcementSchema),
}

export const announcement_getsByClassesOwner_Api = {
    name: 'announcement_getsByClassesOwner_Api',
    backend: `Route::get('announcements/owner/{type}/{id}/gets', 'AnnouncementController@getsByClassesOwner');`,
    root: API_ROOT_URL,
    path: '/announcements/owner/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id', 'status'],
    schema: announcementSchema,
    transform: createListTransform(announcementSchema),
}

export const announcement_getsByCoursesOwner_Api = {
    name: 'announcement_getsByCoursesOwner_Api',
    backend: `Route::get('announcements/owner/{type}/{id}/courses-gets', 'AnnouncementController@getsByCoursesOwner');`,
    root: API_ROOT_URL,
    path: '/announcements/owner/:type/:id/courses-gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_id', 'status'],
    schema: announcementSchema,
    transform: createListTransform(announcementSchema),
}

export const announcement_getsByStudent_Api = {
    name: 'announcement_getsByStudent_Api',
    backend: `Route::get('announcements/student/{id}/gets', 'AnnouncementController@getsByStudent');`,
    root: API_ROOT_URL,
    path: '/announcements/student/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id', 'month_number', 'year_number', 'sort_by'],
    schema: announcementSchema,
    transform: createListTransform(announcementSchema),
}

export const announcement_getsByTeacher_Api = {
    name: 'announcement_getsByTeacher_Api',
    backend: `Route::get('announcements/teacher/{id}/gets', 'AnnouncementController@getsByTeacher');`,
    root: API_ROOT_URL,
    path: '/announcements/teacher/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id', 'month_number', 'year_number', 'sort_by'],
    schema: announcementSchema,
    transform: createListTransform(announcementSchema),
}

export const notification_getMyOrganizationAnnouncements_Api = {
    backend: `Route::get('notifications/{type}/get-announcements', 'NotificationController@getMyAnnouncements');`,
    root: API_ROOT_URL,
    path: '/notifications/organization/get-announcements',
    method: 'GET',
    schema: announcementSchema,
    transform: createListTransform(announcementSchema),
}

export const notification_getMyCourseAnnouncements_Api = {
    backend: `Route::get('notifications/{type}/get-announcements', 'NotificationController@getMyAnnouncements');`,
    root: API_ROOT_URL,
    path: '/notifications/course/get-announcements',
    method: 'GET',
    schema: announcementSchema,
    transform: createListTransform(announcementSchema),
}

// type=course_admin - thông báo của Khóa/Lớp thuộc MỌI tổ chức mà user login là owner/admin
// (role_id 1/2), gộp SẴN 1 query ở BE (NotificationController::getMyAnnouncements case
// "course_admin") - THAY cho việc FE tự lặp gọi announcement_getsByCoursesOwner_Api +
// announcement_getsByClassesOwner_Api CHO TỪNG org (từng gây N tổ chức x 2 request cùng lúc ở tab
// "Trang chủ" /edu, xem EducationHomePanel.js::useAdminOrgAnnouncements).
export const notification_getMyAdminCourseAnnouncements_Api = {
    backend: `Route::get('notifications/{type}/get-announcements', 'NotificationController@getMyAnnouncements');`,
    root: API_ROOT_URL,
    path: '/notifications/course_admin/get-announcements',
    method: 'GET',
    schema: announcementSchema,
    transform: createListTransform(announcementSchema),
}
